import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const Footer = () => {
  const { version } = useSelector(state => state.config);
  return (
    <footer className="footer">
      <Row className="justify-content-between text-center fs-10 mt-4 mb-3">
        <Col sm="auto">
          <p className="mb-0 text-600">
            Land Futures &copy; {new Date().getFullYear()}
          </p>
        </Col>
        <Col sm="auto">
          <p className="mb-0 text-600">v{version}</p>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
